import { RootState } from '@/store/types'
import { CommitOptions, DispatchOptions, Module, Store as VuexStore } from 'vuex'
import { Actions } from './actions/action-types'
import { actions } from './actions/actions'
import { getters } from './getters/getters'
import { Mutations } from './mutations/mutation-types'
import { mutations } from './mutations/mutations'
import { AnimalState, IAnimalFilterOrderBy } from './types'

// LocalStorage key to persist Animals filters
export const ANIMALS_FILTER_STORAGE_KEY = 'animals.filter.v1'

// Default filters for Animals module
export const DEFAULT_ANIMAL_FILTERS = {
	page: 1,
	limit: 8,
	search: undefined as string | undefined,
	orderBy: undefined as IAnimalFilterOrderBy | undefined,
	orderDirection: undefined as 'ASC' | 'DESC' | undefined,
	speciesId: undefined as number | undefined,
	breedId: undefined as number | undefined,
	customerId: undefined as number | undefined,
	hasRequests: undefined as boolean | undefined,
	hasRelationships: undefined as boolean | undefined,
	sex: undefined as 'M' | 'F' | 'I' | undefined,
}

function loadPersistedAnimalFilters() {
	try {
		const raw = localStorage.getItem(ANIMALS_FILTER_STORAGE_KEY)

		if (!raw) return { ...DEFAULT_ANIMAL_FILTERS }

		const parsed = JSON.parse(raw)

		return { ...DEFAULT_ANIMAL_FILTERS, ...parsed }
	} catch (e) {
		return { ...DEFAULT_ANIMAL_FILTERS }
	}
}

export const state: AnimalState = {
	animals: {
		data: [],
		meta: {
			filters: loadPersistedAnimalFilters(),
			loading: false,
		},
	},
	openModalCreateAnimal: false,
	openModalUpdateAnimal: false,
	openStakeholderSelection: false,
	animalSelected: undefined,
	actorsSelected: [],
	isFiltersNotSaved: false,
}

export type Store<S = AnimalState> = Omit<VuexStore<S>, 'commit' | 'getters' | 'dispatch'> & {
	commit<K extends keyof Mutations, P extends Parameters<Mutations[K]>[1]>(
		key: K,
		payload: P,
		options?: CommitOptions
	): ReturnType<Mutations[K]>
} & {
	dispatch<K extends keyof Actions>(
		key: K,
		payload: Parameters<Actions[K]>[1],
		options?: DispatchOptions
	): ReturnType<Actions[K]>
}

export const ANIMAL_NAMESPACE = 'Animals'

export const animal: Module<AnimalState, RootState> = {
	namespaced: true,
	state: state,
	getters: getters,
	actions: actions,
	mutations: mutations,
}
